import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import CssBaseline from '@mui/material/CssBaseline';
import Grid from '@mui/material/Grid';
import Link from '@mui/material/Link';
import { styled } from '@mui/material/styles';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import { SP360Logo } from 'assets';
import React, { useState, useEffect } from 'react';
import { Link as DomLink } from 'react-router-dom'; // Import the Link component

import { AuthenticationMethod } from '../../../src/views/UserProfile';

function Copyright() {
  return (
    <Typography variant="body2" style={{ color: 'white' }} align="center">
      {'Copyright © '}
      <Link color="inherit" href="/">
        SecurePoint 360
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}

const PREFIX = 'VerifyOTP';

const classes = {
  paper: `${PREFIX}-paper`,
  avatar: `${PREFIX}-avatar`,
  form: `${PREFIX}-form`,
  submit: `${PREFIX}-submit`,
};

const Root = styled('div')(({ theme }) => ({
  [`&.${classes.paper}`]: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  [`& .${classes.avatar}`]: {
    margin: theme.spacing(1),
    backgroundColor: '#FFFFFF',
    height: '60px',
    width: '60px',
  },
  [`& .${classes.form}`]: {
    width: '100%', // Fix IE 11 issue
    marginTop: theme.spacing(1),
  },
  [`& .${classes.submit}`]: {
    margin: theme.spacing(3, 0, 2),
  },
}));

export default function VerifyOTP(props) {
  const [mfaCodeRequested, setMfaCodeRequested] = useState(false);
  const [remainingTime, setRemainingTime] = useState(60); // Initial value in seconds
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (mfaCodeRequested) {
      const interval = setInterval(() => {
        setRemainingTime((prevTime) => {
          if (prevTime === 1) {
            setMfaCodeRequested(false);
            clearInterval(interval);
            return 60; // Reset timer to 60 seconds
          }
          return prevTime - 1;
        });
      }, 1000);

      return () => clearInterval(interval);
    }
  }, [mfaCodeRequested]);

  useEffect(() => {
    // Redirect user to login page after 2 minutes
    // 2 Mins =(2 * 60 * 1000 = 120000ms)
    // If mfa_method is TOTP
    const redirectTimeout = setTimeout(() => {
      // callback function to handle the redirect
      if (props.parentContext.state.mfa_method === AuthenticationMethod.TOTP) {
        props.parentContext.redirectToLogin();
      }
    }, 2 * 60 * 1000);

    // Clear the timeout to prevent it from triggering after unmounting
    return () => clearTimeout(redirectTimeout);
  }, [props]);

  const handleResendClick = () => {
    // Logic to resend the MFA code goes here
    // You might make an API call to trigger the resend

    props.resendOtp();
    setRemainingTime(60);

    // For this example, let's just simulate the request
    setMfaCodeRequested(true);
    setTimeout(() => {
      setMfaCodeRequested(false);
    }, 60000); // Allow resending after 1 minute
  };

  const handleVerifyOTP = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      await props.verifyOTP();
    } catch (e) {
      console.log('error', e);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <Container component="main" maxWidth="xs">
        <CssBaseline />
        <Root className={classes.paper + ' white-form-div'}>
          <Avatar className={classes.avatar + ' avatar-logo'}>
            <img alt="vCISO" className="logo" src={SP360Logo} />
          </Avatar>
          <Typography component="h1" variant="h5" style={{}}>
            Verify this device
          </Typography>
          <form className={classes.form} onSubmit={handleVerifyOTP}>
            {props.parentContext.state.mfa_method ===
              AuthenticationMethod.Email && (
              <>
                <br />
                <p>
                  Check your{' '}
                  <strong>{props.parentContext.state.masked_email}</strong> for
                  MFA code.
                </p>
              </>
            )}
            <TextField
              variant="outlined"
              margin="normal"
              required={true}
              fullWidth
              id="otp"
              type="text"
              label="Enter the MFA code"
              name="otp"
              autoComplete="otp"
              autoFocus
              onChange={(element) => {
                props.setValue('otp', element.target.value);
              }}
            />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              color="primary"
              disabled={isLoading}
              className={classes.submit}
            >
              Verify
            </Button>
            {props.parentContext.state.mfa_method ===
            AuthenticationMethod.TOTP ? (
              <Grid container>
                <Grid item xs>
                  <Link
                    href={`/change-mfa?mfa_email=${encodeURIComponent(
                      props.parentContext.state.email,
                    )}&masked_email=${encodeURIComponent(
                      props.parentContext.state.masked_email,
                    )}`}
                    onClick={() => {}}
                    variant="body2"
                  >
                    Lost your MFA configured device?
                  </Link>
                </Grid>
              </Grid>
            ) : (
              <Grid container>
                <Grid item xs>
                  {mfaCodeRequested ? (
                    <p>
                      Success, wait <strong>{remainingTime}</strong> seconds
                      before requesting again.
                    </p>
                  ) : (
                    <DomLink to="#" onClick={handleResendClick}>
                      Resend MFA Code
                    </DomLink>
                  )}
                </Grid>
              </Grid>
            )}
          </form>
        </Root>
        <Box mt={8}>
          <Copyright />
        </Box>
      </Container>
    </>
  );
}
